<template>
  <div class="starter-kit-detail" v-if="starterKit !== null">
    <div class="content">
      <h1 class="main-title">{{starterKit.name}}</h1>

      <div class="author">by {{starterKit['author-name']}}</div>

      <div class="panels">

        <div class="panel">
          <div class="title">OVERVIEW</div>

          <div class="description">
            {{starterKit.overview}}
          </div>
        </div>

      </div>

      <div class="panels">

        <div class="panel">
          <div class="title">HIGHLIGHTS</div>

          <div class="description">
            <ul>
              <li v-for="(item, index) in starterKit.highlights" :key="index">{{item}}</li>
            </ul>
          </div>
        </div>

        <div class="panel">
          <div class="title">COMPATIBILITY</div>

          <div class="description types">
            <div class="item" v-show="isScreen || isSketch">
              <div class="image">
                <img src="../../assets/sketch.png" alt=""/>
              </div>

              Sketch (v43.1+), 15.4MB
            </div>

            <div class="item" v-show="isScreen || isFigma">
              <div class="image">
                <img src="../../assets/figma.png" alt=""/>
              </div>

              Figma
            </div>

            <div class="item" v-show="isScreen || isStudio">
              <div class="image">
                <img src="../../assets/studio.png" alt=""/>
              </div>

              Studio
            </div>

            <div class="item" v-show="isScreen || isXd">
              <div class="image">
                <img src="../../assets/xd.png" alt=""/>
              </div>

              Xd
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="items" v-if="!isScreen">
      <div
        class="item image-responsive"
        v-for="(item, index) in starterKit['preview-asset-ids']"
        :key="index"
      >
        <img :src="`${serverUrl}/color-themes/svg/${styleRuleId}?id=${item}&${colors.map(c => `color=${c.hex.substr(1).toLowerCase()}`).join('&')}`" alt=""/>
      </div>
    </div>
    <div class="items" v-else>
      <div
        class="item image-responsive"
        v-for="(item, index) in styleAssets"
        :key="index"
      >
        <img :src="item['source-url']" alt=""/>
      </div>
    </div>
  </div>
</template>

<script>
import { SERVER_URL } from '../../utils/config';

export default {
  name: 'starter-kit-detail',
  props: {
    starterKit: Object,
    styleRuleId: String,
    styleAssets: Array,
    colors: Array,
    isSketch: Boolean,
    isFigma: Boolean,
    isScreen: Boolean,
    isStudio: Boolean,
    isXd: Boolean,
  },
  data() {
    return {
      serverUrl: SERVER_URL,
    };
  },
};
</script>

<style lang="scss" scoped>
  .content {
    @include media($notMobile) {
      padding: 0 15px;
    }
  }

  .main-title {
    margin-bottom: 10px;
  }

  .author {
    margin-bottom: 45px;

    @include media($mobile) {
      margin-bottom: 25px;
    }
  }

  .panels {
    @include media($notMobile) {
      display: flex;
      margin: 0 -15px;
    }
  }

  .panel {
    margin-bottom: 40px;
    flex: 1 1 50%;

    @include media($notMobile) {
      padding: 0 15px;
    }

    ul {
      padding-left: 15px;
    }
  }

  .title {
    font-size: 14px;
    font-weight: bold;
    opacity: .3;
    margin-bottom: 15px;
  }

  .types {
    .item {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }

    .image {
      width: 30px;
      margin-right: 10px;
      text-align: center;
    }
  }

  .items {
    margin-bottom: 100px;

    .item {
      border-radius: 4px;
      box-shadow: 0 14px 19px rgba(black, .08);
      margin-bottom: 30px;
      overflow: hidden;
    }
  }
</style>
